module.exports = __webpack_public_path__ + "img/icon-robot.78320c37.png";